import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field, Form, Formik } from 'formik';
import Yup from 'yup';
import ModalHeader from 'modal/components/ModalHeader';
import MainTitle from 'base/components/MainTitle';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import SpinnerOverlay from 'base/components/SpinnerOverlay';
import theme, { textBold } from 'theme/theme';
import { changePassword } from '../../store/auth/actions';
import { getChangePasswordHasError, getChangePasswordIsLoading } from '../../store/auth/selectors';

const ErrorMessage = styled.div`
  margin: 0 0 2rem 0;
  ${textBold};
  color: ${theme.colors.white};
  background: ${theme.colors.primary};
  padding: 5px;
`;

const ChangePasswordModal = ({ isLoading, hasError, changePassword }) => (
  <>
    <ModalHeader>
      <MainTitle>Change Password</MainTitle>
    </ModalHeader>
    <FieldWrapper>
      Note: for security reasons, you will be logged out after changing your password.
    </FieldWrapper>

    {hasError && (
      <ErrorMessage>Old password is not valid. Please try again.</ErrorMessage>
    )}

    {isLoading
      ? (<SpinnerOverlay color="#fff" background={theme.colors.dark} label="Changing password" />)
      : (
        <Formik
          initialValues={{
            oldPassword: '',
            newPassword: '',
            newPasswordConfirmation: '',
          }}
          validationSchema={
              Yup.object().shape({
                oldPassword: Yup.string()
                  .required('Old password is required.'),
                newPassword: Yup.string()
                  .required('Old password is required.')
                  .min(6, 'Minimum 6 characters required')
                  .notOneOf([Yup.ref('oldPassword')], 'New password must be different from old password'),
                newPasswordConfirmation: Yup.string()
                  .required('New password confirmation is required.')
                  .min(6, 'Minimum 6 characters required')
                  .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
              })
            }
            render={({errors, isSubmitting}) => ( // eslint-disable-line
              <Form>
                <Field
                  type="password"
                  name="oldPassword"
                  label="Old password"
                  component={FormikInputField}
                />
                <Field
                  type="password"
                  name="newPassword"
                  label="New password"
                  component={FormikInputField}
                />
                <Field
                  type="password"
                  name="newPasswordConfirmation"
                  label="Confirm new password"
                  component={FormikInputField}
                />
                <SubmitButton type="submit" disabled={false}>
                    Change password
                </SubmitButton>
              </Form>
            )}
          onSubmit={(values) => {
            changePassword(values.oldPassword, values.newPassword);
          }}
        />
      )}
  </>
);
ChangePasswordModal.propTypes = {
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  changePassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hasError: getChangePasswordHasError(state),
  isLoading: getChangePasswordIsLoading(state),
});
const mapDispatchToProps = {
  changePassword,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePasswordModal);
